// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__1L1ia","description":"PatientConsentPreview_description__29xxA"};